import Badge from '@material-ui/core/Badge'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import IconButton from '@material-ui/core/IconButton'
import { getNotification, putNotification } from 'api/notification'
import classNames from 'classnames'
import { env } from 'env'
import { onMessage } from 'firebase/messaging'
import { ReactComponent as BellBadge } from 'images/icons/bell-badge.svg'
import Sound from 'ping-alert2-high.wav'
import Sound2 from 'ping-alert2.wav'
import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { fetchToken, messaging } from '../../../../firebase'
import {
	Button,
	Container,
	FormControlLabel,
	FormGroup,
	Hr,
	LinkError,
	NotificationContainer,
	NotificationMenu,
	Subtitle,
	Switch,
	Title,
} from './style'
import Toast from './toast'

const Notification = props => {
	const { i18nState } = useSelector(state => state)
	const translate = i18nState.translations[i18nState.lang]['Notification']
	const notificationConfig = localStorage.getItem('notificationConfig')
	let audio = new Audio(
		env.REACT_APP_API_URL.includes('tracbel')
			? `${window.location.origin}${Sound}`
			: `${window.location.origin}${Sound2}`
	)
	const location = useLocation()
	const [open, setOpen] = useState(false)
	const [value, setValue] = useState({
		display_pop_up: true,
		sound: false,
		sla: false,
		new_message_protocol: false,
		new_message_ticket: false,
		transfer_protocol: false,
		confirm_cpc: false,
		token: null,
	})

	const [isTokenFound, setTokenFound] = useState(false)

	onMessage(messaging, payload => {
		const messageTitle = payload.data.messageTitle
		const messageText = payload.data.messageText
		const click_action = payload.data.click_action
		audio.play()

		toast.custom(t => (
			<Toast
				onClose={() => {
					toast.remove(t.id)
				}}
				notifications={{
					title: messageTitle,
					body: messageText,
					url: click_action,
				}}
				translate={translate}
			/>
		))
	})

	useEffect(() => {
		const getFetchToken = async () => {
			const data = await fetchToken(setTokenFound)
			setValue(data)
		}

		getFetchToken()
	}, [open, location.pathname])

	const handleChange = event => {
		setValue(prevState => ({
			...prevState,
			[event.target.name]: event.target.checked,
		}))
	}

	useEffect(() => {
		getNotification().then(res => {
			setValue({
				display_pop_up: res.data.display_pop_up,
				sound: res.data.sound,
				sla: res.data.sla,
				new_message_protocol: res.data.new_message_protocol,
				new_message_ticket: res.data.new_message_ticket,
				transfer_protocol: res.data.transfer_protocol,
				confirm_cpc: res.data.confirm_cpc,
				token: res.data.token,
			})
		})
	}, [open])

	const handleSubmit = () => {
		if (value) {
			const data = {
				display_pop_up: value.display_pop_up,
				sound: value.sound,
				sla: value.sla,
				new_message_protocol: value.new_message_protocol,
				new_message_ticket: value.new_message_ticket,
				transfer_protocol: value.transfer_protocol,
				confirm_cpc: value.confirm_cpc,
				token: value.token ? value.token : notificationConfig,
			}

			putNotification(data).then(res => {
				audio.play()
				toast.success(translate?.toast_success)
				setOpen(false)
			})
		} else {
			toast.error(
				<LinkError
					href={'https://docs.digitalk.com.br/'}
					target="_blank"
					rel="noreferrer"
				>
					{translate?.toast_error_token}
				</LinkError>
			)
		}
	}

	return (
		<>
			<ClickAwayListener onClickAway={() => setOpen(false)}>
				<Container>
					<Badge classes={{ badge: 'badge', root: 'buttonContainer' }}>
						<IconButton onClick={() => setOpen(prevState => !prevState)}>
							<BellBadge />
						</IconButton>
					</Badge>
					<NotificationContainer className={classNames({ hidden: !open })}>
						<NotificationMenu>
							<Title>{translate?.title}</Title>
							<Subtitle>{translate?.type}</Subtitle>
							<FormGroup>
								<FormControlLabel
									control={
										<Switch
											name="display_pop_up"
											size="small"
											checked={value?.display_pop_up}
											onChange={handleChange}
										/>
									}
									label={translate?.display_pop_up}
								/>
								<FormControlLabel
									control={
										<Switch
											name="sound"
											size="small"
											checked={value?.sound}
											onChange={handleChange}
										/>
									}
									label={translate?.sound}
								/>
								<Hr />
								<Subtitle>{translate?.toNotify}</Subtitle>
								<FormControlLabel
									control={
										<Switch
											name="sla"
											size="small"
											checked={value?.sla}
											onChange={handleChange}
										/>
									}
									label={translate?.sla}
								/>
								<FormControlLabel
									control={
										<Switch
											name="new_message_protocol"
											size="small"
											checked={value?.new_message_protocol}
											onChange={handleChange}
										/>
									}
									label={translate?.new_message_protocol}
								/>
								<FormControlLabel
									control={
										<Switch
											name="new_message_ticket"
											size="small"
											checked={value?.new_message_ticket}
											onChange={handleChange}
										/>
									}
									label={translate?.new_message_ticket}
								/>
								<FormControlLabel
									control={
										<Switch
											name="transfer_protocol"
											size="small"
											checked={value?.transfer_protocol}
											onChange={handleChange}
										/>
									}
									label={translate?.transfer_protocol}
								/>
								<FormControlLabel
									control={
										<Switch
											name="confirm_cpc"
											size="small"
											checked={value?.confirm_cpc}
											onChange={handleChange}
										/>
									}
									label={translate?.confirm_cpc}
								/>
							</FormGroup>
							<Button onClick={handleSubmit}>{translate?.saveEdition}</Button>
						</NotificationMenu>
					</NotificationContainer>
				</Container>
			</ClickAwayListener>
			<Toaster position="top-right" duration={5000} />
		</>
	)
}

export default Notification
